import { createSlice } from '@reduxjs/toolkit';
import { getJobs } from 'ducks/jobs/operators';
import { normalizeJobs } from 'ducks/jobs/utils';
import { Slices } from 'ducks/slices';
import { JobItem } from 'ducks/types/store-types';

export type JobsState = JobItem[];

const initialState: JobsState = [];

const jobsSlice = createSlice({
  name: Slices.JOBS,
  initialState,
  reducers: {
    clearJobs: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJobs.pending, () => {
        return initialState;
      })
      .addCase(getJobs.fulfilled, (_, { payload }) => {
        return normalizeJobs(payload);
      })
      .addCase(getJobs.rejected, () => {
        return initialState;
      });
  },
});

export const { clearJobs } = jobsSlice.actions;

export default jobsSlice.reducer;
